( function( $ ){

    if( ! $( 'section.embedded_gallery' ).length ){
        return;
    }

    const switch_gallery_slide = ( $gallery, new_index ) => {
        $gallery.find( '.gallery-dot.active' ).removeClass( 'active' );
        $gallery.find( '.gallery-dot[data-index="'+ new_index +'"]' ).addClass( 'active' );
        $gallery.find( '.gallery-item.active' ).removeClass( 'active' );
        $gallery.find( '.gallery-item[data-index="'+ new_index +'"]' ).addClass( 'active' );
    }

    $( '.gallery-dot' ).on( 'click', function(){
        let index = $(this).attr('data-index');
        switch_gallery_slide( $(this).closest('.embedded_gallery'), index );
    });

    $( '.gallery-button' ).on( 'click', function(){
        let $gallery    = $(this).closest('.embedded_gallery');
        let index       = parseInt( $gallery.find( '.gallery-item.active' ).attr( 'data-index' ) );
        if( $(this).hasClass( 'gallery-last' ) ){
            index = 1 == index ? $gallery.find( '.gallery-dot' ).length : index - 1;
        }
        else{
            index = $gallery.find( '.gallery-dot' ).length == index ? 1 : index + 1;
        }
        switch_gallery_slide( $gallery, index );
    });

})( jQuery );